{
    "UnreturnedCallsFilterSectionTitle": "Filtragem de chamadas não atendidas",
    "UnreturnedCallsFilterSectionDesc": "Também pode controlar que tipos de chamadas recebidas são incluídas nos relatórios de \"Chamadas Perdidas Não devolvidas\"",
    "UnreturnedCallsFilter_IncludeEscapedLabel": "Incluir chamadas escapadas:",
    "UnreturnedCallsFilter_IncludeDivertedOverflowedLabel": "Incluir chamadas desviadas\/sobrecarregadas:",
    "UnreturnedCallsFilter_IncludeTransferredLabel": "Incluir chamadas transferidas:",
    "UnreturnedCallsFilter_IncludeAllOtherLabel": "Incluir todas as outras chamadas:",
    "NAME": "UnreturnedCallsFilter"
}